import { GenericError } from '@cian/peperrors/shared';

interface IToLoggableErrorParams {
  /** Тип ошибки, попадает в заголовок лога (`Error.name`) */
  type: string;
  /** Домен, по нему ошибки агрегируются в ELK (`exception_type`) */
  domain: string;
  /** Сообщение. По умолчанию берётся из исходной ошибки */
  message?: string;
}

function describeValue(value: unknown): string {
  if (typeof value === 'string') {
    return value;
  }

  try {
    return JSON.stringify(value) || String(value);
  } catch {
    return String(value);
  }
}

/**
 * Оборачивает произвольное значение из `catch` в настоящий `Error`, пригодный для `logger.error`.
 *
 * Логгер приводит к строке всё, что не является экземпляром `Error`, поэтому спред ошибки
 * (`logger.error({ ...err, domain })`) даёт в логах `UnknownError: [object Object]`: спред не копирует
 * `message` и `stack` (это non-enumerable свойства), а домен и детали теряются при оборачивании
 * в `UnknownError` внутри логгера.
 *
 * Исходная ошибка попадает в `details`, логгер разворачивает её в цепочку `Caused by:`.
 * Дополнительный контекст (микросервис, ручка, параметры) передавайте вторым аргументом `logger.error`.
 */
export function toLoggableError(error: unknown, { type, domain, message }: IToLoggableErrorParams): GenericError {
  const isError = error instanceof Error;

  return new GenericError({
    type,
    domain,
    message: message || (isError ? error.message : describeValue(error)),
    details: isError ? error : { error: describeValue(error) },
  });
}
